type Props = {
  variant?: 'onLight' | 'onDark';
};

export function Logo({ variant = 'onLight' }: Props) {
  const isDark = variant === 'onDark';
  return (
    <div className="flex items-center gap-3">
      <div className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary-400 to-primary-600 shadow-[0_0_0_1px_rgba(204,0,0,0.25),0_8px_24px_-12px_rgba(204,0,0,0.55)]">
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5 text-white"
          aria-hidden="true"
          fill="currentColor"
        >
          <path d="M12 2 L13.6 8.2 L19.8 6.4 L15.8 11.4 L21 13 L14.9 14.9 L17 21 L12 16.5 L7 21 L9.1 14.9 L3 13 L8.2 11.4 L4.2 6.4 L10.4 8.2 Z" />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`text-xl font-bold tracking-tight ${
            isDark ? 'text-white' : 'text-slate-900'
          }`}
        >
          NexaClaim <span className="text-primary-500">AI</span>
        </span>
        <span
          className={`mt-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] ${
            isDark ? 'text-white' : 'text-slate-900'
          }`}
        >
          Revenue Cycle Intelligence
        </span>
      </div>
    </div>
  );
}
